import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { Toolbar } from '@kerfjs/ui/toolbar';
import { ToolbarControlGroup } from '@kerfjs/ui/toolbar-control-group';
import type { SafeHtml } from 'kerfjs';
import { Minus, Plus } from 'lucide';

import { DOCUMENT_GALLERY_ZOOM_STOPS } from '../../../../../lib/document-gallery-zoom.js';

export function GalleryZoomFooter({ zoom }: { zoom: number }): SafeHtml {
  return (
    <div class="gallery-zoom-footer document-preview-footer">
      <Toolbar
        dividerSides=""
        trailing={
          <ToolbarControlGroup label="Image Zoom" tone="dark">
            <button
              type="button"
              data-action="document-preview-zoom"
              data-item-id="-1"
              aria-label="Zoom Out"
              title="Zoom out"
              disabled={zoom <= DOCUMENT_GALLERY_ZOOM_STOPS[0]}
            >
              <LucideIcon icon={Minus} name="" />
            </button>
            <button
              type="button"
              data-action="document-preview-zoom"
              data-item-id="1"
              aria-label="Zoom In"
              title="Zoom in"
              disabled={zoom >= (DOCUMENT_GALLERY_ZOOM_STOPS.at(-1) ?? 3)}
            >
              <LucideIcon icon={Plus} name="" />
            </button>
          </ToolbarControlGroup>
        }
      />
    </div>
  );
}
